import { osName } from 'react-device-detect';

import {
  generatePostAction, generateGetAction, generateAction,
  generatePutAction,
} from '@services/ActionDispatcher';
import { CLIENT_EXTERNAL_TYPES } from '@shared/constants';

import {
  loginAction,
  logoutAction,
  updateFcmTokenAction,
  clearUserTokenAction,
  getUserDetailsAction,
  registerAction,
  resendVerificationAction,
  verifyEmailAction,
  loginWithGoogleAction,
  loginWithTwitterAction,
  forgotPassSendVerificationCodeAction,
  forgotPassVerifyCodeAction,
  sendVerificationCodeAction,
  verifyCodeAction,
  changePasswordAction,
  loginWithMicrosoftAction,
  registrationTypeAction,
  setVerificationAccessTokenAction,
  updateEmailOrMobileAction,
} from './AuthActionConfig';

const registrationTypeDispatch = (data: any) => generateAction(registrationTypeAction, data);
const setVerificationAccessTokenDispatch = (data: any) => generateAction(
  setVerificationAccessTokenAction, data);

const deviceData = () => ({
  device_uuid: localStorage.getItem('DEVICE_UUID'),
  device_os: osName,
  ip_address: localStorage.getItem('IP_ADDRESS'),
});

const clearUserTokenRequest = () => generateAction(
  clearUserTokenAction,
);

// action request dispatchers
const loginRequest = (data: any) => generatePostAction(
  // action name
  loginAction,
  // url
  'auth/login',
  { ...data, ...deviceData() },
  // { withCredentials: true },
);

const updateFcmTokenRequest = (data: any) => generatePutAction(
  // action name
  updateFcmTokenAction,
  'auth/update-fcm-token',
  { ...data, ...deviceData() },
);

const loginWithGoogleRequest = (data: any) => generatePostAction(
  // action name
  loginWithGoogleAction,
  // url
  'auth/login/external',
  { ...data, ...deviceData(), type: CLIENT_EXTERNAL_TYPES.google },
);

const loginWithMicrosoftRequest = (data: any) => generatePostAction(
  // action name
  loginWithMicrosoftAction,
  // url
  'auth/login/external',
  { ...data, ...deviceData(), type: CLIENT_EXTERNAL_TYPES.microsoft },
);

const loginWithTwitterRequest = (data: any) => generatePostAction(
  // action name
  loginWithTwitterAction,
  // url
  'twitter-login',
  { ...data, ...deviceData() },
);

const logoutRequest = () => generatePostAction(
  // action name
  logoutAction,
  // url
  'auth/logout',
  { ...deviceData() },
);

const getUserDetailsRequest = () => generateGetAction(
  // action name
  getUserDetailsAction,
  // url
  'auth/me',
  { queryParams: deviceData() },
  // { withCredentials: true },
);

const registerRequest = (data: any) => generatePostAction(
  // action name
  registerAction,
  // url
  'auth/register',
  { ...data, ...deviceData() },
);

const verifyEmailRequest = (data: any) => generatePostAction(
  // action name
  verifyEmailAction,
  // url
  'verify-email',
  { ...data, ...deviceData() },
);

const resendVerificationRequest = (data: any) => generatePostAction(
  // action name
  resendVerificationAction,
  // url
  'resend-verification',
  { ...data, ...deviceData() },
);

const sendVerificationCodeRequest = (data: any) => generatePostAction(
  // action name
  sendVerificationCodeAction,
  // url
  'auth/code/send',
  data,
);

const verifyCodeRequest = (data: any) => generatePostAction(
  // action name
  verifyCodeAction,
  // url
  'auth/code/verify',
  data,
);

const forgotPassSendVerificationCodeRequest = (data: any) => generatePostAction(
  // action name
  forgotPassSendVerificationCodeAction,
  // url
  'auth/forgot-password/send-code',
  data,
);

const forgotPassVerifyCodeRequest = (data: any) => generatePostAction(
  // action name
  forgotPassVerifyCodeAction,
  // url
  'auth/forgot-password/verify-code',
  data,
);

const changePasswordRequest = (data: any) => generatePostAction(
  // action name
  changePasswordAction,
  'auth/forgot-password/change-password',
  data,
);

const updateEmailOrMobileRequest = (payloadType: any, data: any) => generatePutAction(
  // action name
  updateEmailOrMobileAction,
  `auth/profile/${payloadType}`,
  data,
);

// register actions here
export {
  // normal dispatch
  clearUserTokenRequest,
  registrationTypeDispatch,
  setVerificationAccessTokenDispatch,

  // async (request) dispatch
  loginRequest,
  logoutRequest,
  updateFcmTokenRequest,
  registerRequest,
  getUserDetailsRequest,
  verifyEmailRequest,
  resendVerificationRequest,
  loginWithGoogleRequest,
  loginWithMicrosoftRequest,
  loginWithTwitterRequest,
  sendVerificationCodeRequest,
  verifyCodeRequest,
  changePasswordRequest,
  updateEmailOrMobileRequest,
  forgotPassSendVerificationCodeRequest,
  forgotPassVerifyCodeRequest,
};
